import { Modal } from "antd";
import { FC } from "react";

import styles from "./index.less";

import SpinIcon from "../../../../assets/svg/spin.svg";

interface AllocatingResourcesModalProps {
  open: boolean;
}

/**
 * 资源分配中
 */
const AllocatingResourcesModal: FC<AllocatingResourcesModalProps> = ({
  open,
}) => {
  return (
    <Modal
      centered
      width={240}
      open={open}
      maskClosable={false}
      closable={false}
      footer={null}
    >
      <div className={styles.container}>
        <img src={SpinIcon} alt="spin" className={styles.spin} />
        <div className={styles.description}>资源分配中，请稍后</div>
      </div>
    </Modal>
  );
};

export default AllocatingResourcesModal;
